import { element } from '@shared/easyfy.core';
import { hide, show } from '@shared/easyfy.utils';

export class FilterSEOHelper {
  static hideFirstPageComponents(page: number, itemsQuerySelector: string) {
    const itemsContainer = element(itemsQuerySelector);
    const listParentContainer = itemsContainer?.closest('main[role=main]');
    const firstPageComponents = listParentContainer.querySelectorAll('.first-page-list-elements');

    if (page != 1 && firstPageComponents != null && firstPageComponents.length > 0) {
      firstPageComponents.forEach((x) => {
        hide(x);
      });
    } else if (page == 1) {
      firstPageComponents.forEach((x) => {
        show(x);
      });
    }
  }

  static updateHeadPagination = (currentPage: number, totalPages: number) => {
    let relPrev = element("link[rel='prev']") as HTMLElement;
    let relNext = element("link[rel='next']") as HTMLElement;

    if (currentPage == 1) {
      relPrev?.remove();
    } else if (!relPrev) {
      relPrev = document.createElement('link');
      relPrev.setAttribute('rel', 'prev');
      element('head').appendChild(relPrev);
    }

    if (currentPage == totalPages) {
      relNext?.remove();
    } else if (!relNext) {
      relNext = document.createElement('link');
      relNext.setAttribute('rel', 'next');
      element('head').appendChild(relNext);
    }

    let currBaseLink: string = relNext?.attributes['href']?.value ?? relPrev?.attributes['href']?.value;
    currBaseLink = currBaseLink?.split('?')[0];

    if (currentPage == 2) {
      relPrev.setAttribute('href', currBaseLink);
    } else {
      relPrev?.setAttribute('href', currBaseLink + '?p=' + (currentPage - 1));
    }

    relNext?.setAttribute('href', currBaseLink + '?p=' + (+currentPage + 1));
  };

  static updateMetaTitle(page: number, resource: string) {
    const metaTitle = document.querySelector('head > title');
    if (!metaTitle) return;

    let currentMetaTitle = metaTitle.innerHTML;
    const separatorIdx = currentMetaTitle.indexOf('-') + 2;

    if (page > 1) {
      currentMetaTitle = currentMetaTitle.includes(resource) ? currentMetaTitle.slice(separatorIdx) : currentMetaTitle;
      metaTitle.innerHTML = `${resource} ${page} - ${currentMetaTitle}`;
    } else if (currentMetaTitle.includes(resource)) {
      metaTitle.innerHTML = currentMetaTitle.slice(separatorIdx);
    }
  }

  static updateMetaCanonical(page: number) {
    const metaCanonical = document.querySelector("link[rel='canonical']");
    if (!metaCanonical) return;
    let hrefValue = metaCanonical.getAttribute('href');
    if (!hrefValue) return;

    if (page > 1) {
      if (hrefValue.includes('?p=')) {
        const arrayHref = hrefValue.split('?p=');
        hrefValue = arrayHref[0] + '?p=' + page;
      } else {
        hrefValue = hrefValue + '?p=' + page;
      }
    } else {
      if (hrefValue.includes('?p=')) {
        const arrayHref = hrefValue.split('?p=');
        hrefValue = arrayHref[0];
      }
    }
    metaCanonical.setAttribute('href', hrefValue);
  }

  static updateMetaAlternate() {
    const metaCanonical = document.querySelector("link[rel='canonical']");
    if (!metaCanonical) return;
    const canonicalHref = metaCanonical.getAttribute('href');
    if (!canonicalHref) return;
    const culture = document.documentElement.getAttribute('data-culture');
    if (!culture) return;

    document.querySelectorAll("link[rel='alternate']").forEach((link) => link.remove());

    const newAlternate = document.createElement('link');
    newAlternate.setAttribute('rel', 'alternate');
    newAlternate.setAttribute('hreflang', culture);
    newAlternate.setAttribute('href', canonicalHref);

    metaCanonical.insertAdjacentElement('afterend', newAlternate);
  }
}
